<app-loading></app-loading>
<div class="app-container" [class.app-container--chromeless]="hideHeader">
  @if (!hideHeader) {
    <app-header
      [sidebarOpen]="sidebarOpen"
      (sidebarToggle)="toggleSidebar()"
    ></app-header>
  }
  <div class="app-body">
    @if (!hideHeader) {
      <app-sidebar
        [mobileOpen]="sidebarOpen"
        (navigate)="closeSidebar()"
      ></app-sidebar>
    }
    <div class="app-content-column">
      <main class="app-main">
        <router-outlet />
      </main>
      @if (!hideFooter) {
        <app-footer></app-footer>
      }
    </div>
  </div>
</div>
